import React from "react"
import { useStore } from "../../../stores/RootStoreContext"
import { OrderManager } from "../../manager/order/OrderManager"
import { OrderClientCommon } from "../../client/order/OrderClientCommon"

export const Order = () => {
  const { userStore } = useStore()

  if (userStore.isClient) {
    return <OrderClientCommon />
  } else if (userStore.isManagement) {
    return <OrderManager />
  } else {
    return <></>
  }
}
